import React from 'react';
import PropTypes from 'prop-types';
import { DropdownDescriptiveMenu } from '@spark';
import TextField from '@/features/datasets/components/DataCollection/GenerateDataWithAI/shared/TextField';
import FieldLabel from '@/features/datasets/components/DataCollection/GenerateDataWithAI/shared/FieldLabel';
import {
    sessionOptionDescription,
    sessionOptionTitle,
} from '@/features/datasets/utils/retrievalAgentDataset';

const DATASET_NAME_HELP =
    'Name of the dataset this run will create. Must be unique across your datasets.';

/** Placeholder menu entry shown when there are no past sessions to load. */
const NO_SESSIONS_ITEM = {
    title: 'No previous configurations',
    description: 'Configurations from previous runs will appear here.',
    state: 'disabled',
};

/**
 * Row between the records banner and the "Define Task" heading (Generate Data
 * with AI + Dataset Retrieval Agent): an editable Dataset Name (defaulting to
 * the next free session name) next to an equal-width "Load Previous ...
 * Configurations" dropdown that prefills the wizard from a past run.
 */
const DatasetNameLoadRow = ({
    datasetName,
    onDatasetNameChange,
    datasetNameError = '',
    loadLabel,
    sessions = [],
    loadedSessionTitle,
    onLoadSession,
}) => (
    <div className="gdai-row">
        <TextField
            label="Dataset Name"
            required
            help={DATASET_NAME_HELP}
            placeholder="Dataset name"
            value={datasetName}
            onChange={onDatasetNameChange}
            errorText={datasetNameError}
        />
        <div className="gdai-field gdai-load-previous">
            <FieldLabel text={loadLabel} />
            <DropdownDescriptiveMenu
                size="medium"
                placeholder="Select"
                panelClassName="gdai-load-previous__panel"
                value={loadedSessionTitle}
                items={
                    sessions.length
                        ? sessions.map((session) => ({
                              title: sessionOptionTitle(session),
                              description: sessionOptionDescription(session),
                          }))
                        : [NO_SESSIONS_ITEM]
                }
                onSelect={(item, index) => onLoadSession(sessions[index])}
            />
        </div>
    </div>
);

DatasetNameLoadRow.propTypes = {
    datasetName: PropTypes.string.isRequired,
    onDatasetNameChange: PropTypes.func.isRequired,
    datasetNameError: PropTypes.string,
    loadLabel: PropTypes.string.isRequired,
    sessions: PropTypes.arrayOf(PropTypes.object),
    loadedSessionTitle: PropTypes.string,
    onLoadSession: PropTypes.func.isRequired,
};

export default DatasetNameLoadRow;
